import { render, staticRenderFns } from "./DividerView.vue?vue&type=template&id=d1683480&scoped=true"
import script from "./DividerView.vue?vue&type=script&lang=js"
export * from "./DividerView.vue?vue&type=script&lang=js"
import style0 from "./DividerView.vue?vue&type=style&index=0&id=d1683480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1683480",
  null
  
)

export default component.exports